module.exports = __webpack_public_path__ + "img/cards.100cf299.png";